import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IProps {
  displayValue?: string;
}

export const ElementMessage = styled.div`
  padding: 15px 16px 15px 26px;
  border-radius: 5px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  background-color: #FFFFFF;
  z-index: 200;
  width: 280px;
`

export const TextMessage = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
`
export const Element = styled.div`
  display: ${(props: IProps) => (props.displayValue ?? `block`)};
  position: fixed;
  bottom: 20px;
  right: 20px;
  justify-content: center;
  align-items: center;
  z-index: 200;
`
